module.exports = __webpack_public_path__ + "img/TZS09507.080eaabd.jpeg";